import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface MetricListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class MetricListPage extends Component<MetricListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.metric(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}